"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecordFetchError", {
    enumerable: true,
    get: function() {
        return RecordFetchError;
    }
});
const _homeeerror = require("./homee.error");
let RecordFetchError = class RecordFetchError extends _homeeerror.HomeeError {
    constructor(...args){
        super(...args);
        this.name = 'RecordFetchError';
    }
};

//# sourceMappingURL=record-fetch.error.js.map